export default "__VITE_ASSET__rGxXG5dH__"